export enum LlmModelProvider {
  OpenAI = 'openai',
  Gemini = 'gemini'
}

export const getLlmModelProviderSupportFileTypes = (
  provider?: LlmModelProvider | null
): string[] => {
  switch (provider) {
    case LlmModelProvider.OpenAI:
      return ['.pdf'];
    case LlmModelProvider.Gemini:
      return ['.pdf', '.txt'];
    default:
      return ['.pdf'];
  }
};
